export default __webpack_public_path__ + "static/kotlin-754b1ea28d69f272a6bafe0e2a0324d1.svg";